export default __webpack_public_path__ + "static/media/bscott.af8cbd53.jpeg";